import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, ValidationErrors, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as fromInvoice from '../../core/actions/invoice.actions';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
@Component({
  selector: 'app-paiements',
  templateUrl: './paiements.component.html',
  styleUrls: ['./paiements.component.scss']
})
export class PaiementsComponent implements OnInit, OnChanges {

	@Input() invoice: any;
 	form: FormGroup;
 	updated: boolean = false;
  	constructor(private fb: FormBuilder,private store: Store<any>) {

  	}

  	ngOnInit() {
  		this._buildForm();
  	}

  	ngOnChanges(change: SimpleChanges) {
  		if (change.invoice.currentValue) {
  			this._buildForm();
  		}

  	}


  	_buildForm() {
   		  this.form = this.fb.group({
	          'details': this.fb.array(this.invoice.paiements.map(p => {
	          	return this.fb.group({
          'id': [p.id, []],
          'amount': [p.amount, []],
          'date_paiement': [moment(p.date_paiement).toDate(), []],
        });
	          }))
  	    });
   		this.form.valueChanges.subscribe(v => this.updated = true);
    }
	getDetails(): FormArray {
	return         (<FormArray>this.form.controls.details);
	}
    removeDetail(idx: number) {
        (<FormArray>this.form.controls.details).removeAt(idx);
        this.updated = true;
    }

    addDetail() {
        (<FormArray>this.form.controls.details).push(this.fb.group({
          'id': ['', []],
          'amount': [Math.round(this.invoice.tot.tvac * 100) / 100, []],
          'date_paiement': [new Date(), []],
        }));
        this.updated = true;
    }

    onCancel() {
    	this._buildForm();
    	this.updated =false;
    }

    onSave() {
    	this.updated =false;
    	this.store.dispatch(new fromInvoice.SavePaiementsAction(this.invoice.id, this.form.value.details.map(d => {
    		return {
    			id: d.id,
    			amount: d.amount,
    			date_paiement: moment(d.date_paiement).format('YYYY-MM-DD')
    		}
    	})));
    }

}
